export default "__VITE_ASSET__DXw2iuoR__"